import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/main_business',
  component: Layout,
  redirect: '/main_business/index',
  name: 'mainBusiness',
  meta: {
    title: '主营业务',
    icon: 'business',
  },
  children: [
    {
        path: 'index',
        name: 'mainBusinessIndex',
        component: () => import('@/views/component/main_business_index.vue'),
        meta: {
            title: '主营业务首页',
            menu: false,
            breadcrumb: false,
            auth: [
                'Business.MainBusiness.menu'
            ]
        }
    },
    {
        path: 'contract',
        name: 'mainBusinessContractIndex',
        component: () => import('@/views/main_business/contract.vue'),
        meta: {
            title: '合同管理',
            breadcrumb: true,
            auth: [
                'Business.MainBusiness.menu'
            ]
        }
    },
    {
      path: 'contract_detail/:id',
      name: 'mainBusinessContractDetail',
      component: () => import('@/views/main_business/contract_detail.vue'),
      meta: {
        title: '合同详情',
        menu: false,
        activeMenu: '/main_business/contract',
        auth: [
            'Business.MainBusiness.menu'
        ]
      },
    },
    {
        path: 'supplement',
        name: 'mainBusinessSupplementIndex',
        component: () => import('@/views/main_business/supplement.vue'),
        meta: {
            title: '补充协议列表',
            breadcrumb: true,
            auth: [
                'Business.MainBusiness.menu'
            ]
        }
    },
    {
      path: 'supplement_detail/:id',
      name: 'mainBusinessSupplementDetail',
      component: () => import('@/views/main_business/supplement_detail.vue'),
      meta: {
        title: '补充协议详情',
        menu: false,
        activeMenu: '/main_business/supplement',
        auth: [
            'Business.MainBusiness.menu'
        ]
      },
    }
  ],
}

export default routes
